import { render } from "./ModifierAssignation.vue?vue&type=template&id=5affd25d&scoped=true&ts=true"
import script from "./ModifierAssignation.vue?vue&type=script&lang=ts"
export * from "./ModifierAssignation.vue?vue&type=script&lang=ts"

import "./ModifierAssignation.vue?vue&type=style&index=0&id=5affd25d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5affd25d"]])

export default __exports__